import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const LukkSidebar: React.FC<SvgProps> = ({ pathFill = 'none', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 16 16'
			fill={pathFill}
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g id='Ikon'>
				<path
					id='Vector'
					d='M0 14.0002C0 14.4752 0.382143 14.8574 0.857143 14.8574C1.33214 14.8574 1.71429 14.4752 1.71429 14.0002V2.00021C1.71429 1.52521 1.33214 1.14307 0.857143 1.14307C0.382143 1.14307 0 1.52521 0 2.00021V14.0002ZM4.84286 7.37521C4.67143 7.53592 4.57143 7.7645 4.57143 8.00021C4.57143 8.23592 4.66786 8.46092 4.84286 8.62521L9.7 13.1966C10.0464 13.5216 10.5857 13.5038 10.9107 13.1609C11.2357 12.8181 11.2179 12.2752 10.875 11.9502L7.58929 8.85735H10.5714H15.1429C15.6179 8.85735 16 8.47521 16 8.00021C16 7.52521 15.6179 7.14307 15.1429 7.14307H10.5714H7.58929L10.8714 4.05378C11.2179 3.72878 11.2321 3.18592 10.9071 2.84307C10.5821 2.50021 10.0393 2.48235 9.69643 2.80735L4.83929 7.37878L4.84286 7.37521Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};
